import { render, staticRenderFns } from "./InvModal.vue?vue&type=template&id=2ff1f7f2"
import script from "./InvModal.vue?vue&type=script&lang=js"
export * from "./InvModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports